define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/on",
	"dijit/form/Button",
	"lodash",
	"csi/html",
	"csi/widget/FilteringSelectInDropdown"
], function(declare, lang, on, Button, _, html, FilteringSelectInDropdown) {

	// this module implements button "+" for Batch Filter feature. By clicking on this button user sees drop down with list of available column filters and can choose
	// one for filtering. Once chosen, filter pill being created and open its drop down allowing selection of filter values
	// see csi/toolbar/BatchFilter for Batch Filter code

	return declare(Button, {
		showLabel: false,
		iconClass: "material-icons",
		"class": "csi-batch-filter-button",

		/**
		 * @override
		 * listen to mouse down event rather then click to allow toggle behavior and prevent blur on mouse down and instant re-open on mouse up
		 */
		postCreate: function() {
			this.inherited(arguments);
			this.own(
				on(this.domNode, "mousedown", lang.hitch(this, this._onMouseDown)),
			);
			html.text(this.iconNode, "add");
		},

		/**
		 * create and open FilteringSelectInDropdown with list of available columns
		 */
		_onMouseDown: function(ev) {
			const {domNode, queryMixin} = this;
			let filterSelect;

			// the reasons to use debounce:
			// when you do mouse down, following events occurred:
			// create and open drop down
			// move focus to button
			// drop down lost focus and blur occur, so drop down close
			const closeDropDown = _.debounce(() => {
				if (!filterSelect) {
					return;
				}
				domNode.classList.remove("csi-dropdown-open");
				filterSelect.closeDropDown();
				filterSelect.destroy();
				// delay is required to hide button focus flicker, decorative only
				_.delay(() => domNode.classList.remove("csi-hide-focus"), 250);
			}, 100);

			const createDropDown = _.debounce(() => {
				domNode.classList.add("csi-hide-focus");
				domNode.classList.add("csi-dropdown-open");
				filterSelect = new FilteringSelectInDropdown({
					store: queryMixin.querySpecStore,
					onBlur: () => {
						closeDropDown();
					},
					onSelect: () => {
						this.onChange?.(filterSelect.value);
						closeDropDown();
					}
				}).placeAt(domNode, "first");
			}, 100);

			// toggle drop down
			if (!filterSelect) {
				createDropDown();
			} else {
				closeDropDown();
			}
		},

		openDropdown: function() {
			this._onMouseDown();
		}
	});
});